import { GET, httpOk } from 'helpers/api'
import { formatDate, formatMoney } from 'helpers/helpers';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';

function RecipeModal({ modal, setModal, id }) {
    const { t } = useTranslation();


    const [data, setData] = useState({
        order: {},
        items: [],
    })

    useEffect(() => {
        async function getData() {
            const response = await GET(`/production/orders/${id}/recipe/`)
            if (httpOk(response)) {
                setData(response.data)
            }
        }

        if (modal && id) {
            getData()
        } else {
            setData({
                order: {},
                items: [],
            })
        }
    }, [modal, id]);

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)} dialogClassName="second">
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('order_details')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('view_order_details')}
                </div>

                <div className="d-flex flex-column gap-5 w-50">
                    <div className="d-between">
                        <div className="text-second">{t('order_number')}</div>
                        <div className="fw-bold">{data?.order?.order_number}</div>
                    </div>

                    <div className="d-between">
                        <div className="text-second">{t('product')}</div>
                        <div>{data?.order?.product_name}</div>
                    </div>

                    <div className="d-between">
                        <div className="text-second">{t('status')}</div>
                        <div className={`alert alert-${data?.order?.status}`}>{data?.order?.status_label}</div>
                    </div>

                    <div className="d-between">
                        <div className="text-second">{t('planned_start_date')}</div>
                        <div>{formatDate(data?.order?.planned_start_date)}</div>
                    </div>

                    <div className="d-between">
                        <div className="text-secondary">{t('planned_vs_produced')}</div>
                        <div>
                            <span className="fw-bold">{formatMoney(data?.order?.produced_quantity)}</span>
                            {' / '} {formatMoney(data?.order?.planned_quantity)} {data?.order?.unit_short_name}
                        </div>
                    </div>

                    <div className="d-between">
                        <div className="text-secondary">{t('progress')}</div>
                        <div className="fw-bold">
                            {formatMoney(data?.order?.progress_percent)}%
                        </div>
                    </div>

                    <div className="d-between">
                        <div className="text-secondary">{t('warehouse')}</div>
                        <div>{data?.order?.warehouse_name}</div>
                    </div>

                </div>

                <hr />

                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th style={{ width: '25%' }}>{t('raw_material')}</th>
                                <th style={{ width: '10%' }}>{t('recipe_quantity')}</th>
                                <th style={{ width: '10%' }}>{t('planned_quantity')}</th>
                                <th style={{ width: '10%' }}>{t('consumed_quantity')}</th>
                                <th style={{ width: '10%' }}>{t('unit_short')}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data?.items?.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.raw_material_name}</td>
                                    <td>{formatMoney(item.recipe_quantity)}</td>
                                    <td>{formatMoney(item.planned_quantity)}</td>
                                    <td>{formatMoney(item.consumed_quantity)}</td>
                                    <td>{item.unit_short_name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default RecipeModal